import React from 'react'
import { useFormContext } from 'react-hook-form'
import { Box, Grid, Typography } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

const FUNCTION_TYPE_LABELS = {
  CXL: 'Cancellation',
  CHG: 'Change or Update Bill of Lading',
  SWB: 'Switch Bill of Lading',
  RIR: 'Response to an RFI - Information to be provided',
  RIJ: 'Response to an RFI - Information cannot be provided'
}

function FilingUpdateInfoSection({ forceShow = false, children }) {
  const { watch } = useFormContext()
  const functionType = watch('functionType')
  const reason = watch('reasonForUpdatingFiling')
  const hasFunctionTypeInfo = functionType && functionType !== 'NEW'

  if (!hasFunctionTypeInfo && !forceShow) return null

  return (
    <Box
      mb={2}
      style={{
        padding: '16px 18px',
        background: '#fff8e1',
        border: '1px solid #ffe082',
        borderRadius: 8
      }}
    >
      <Box display='flex' alignItems='center' mb={1} style={{ gap: 8 }}>
        <FontAwesomeIcon icon={['fal', 'triangle-exclamation']} style={{ fontSize: 14, flexShrink: 0, color: '#f59e0b' }} />
        <Typography variant='subtitle2'>Filing Update Info</Typography>
      </Box>
      {hasFunctionTypeInfo && (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Typography variant='caption' color='textSecondary' style={{ textTransform: 'uppercase', fontSize: 10, letterSpacing: 0.5 }}>Function Type</Typography>
            <Typography variant='body2' style={{ fontWeight: 600 }}>{FUNCTION_TYPE_LABELS[functionType] || functionType}</Typography>
          </Grid>
          {reason && (
            <Grid item xs={12} sm={8}>
              <Typography variant='caption' color='textSecondary' style={{ textTransform: 'uppercase', fontSize: 10, letterSpacing: 0.5 }}>Reason</Typography>
              <Typography variant='body2' style={{ fontWeight: 600, wordBreak: 'break-word' }}>{reason}</Typography>
            </Grid>
          )}
        </Grid>
      )}
      {children}
    </Box>
  )
}

export default FilingUpdateInfoSection
